(() => {
  if (window.OutlumiBrandCarousels) return;
  const instances = new Map();
  window.OutlumiBrandCarousels = instances;
  const init = root => {
    if (instances.has(root)) return;
    const pages = [...root.querySelectorAll('.olm-brand-page')];
    if (pages.length < 2) return;
    const viewport = root.querySelector('.olm-brand-viewport');
    const dots = root.querySelector('[data-brand-dots]');
    const abort = new AbortController(), options = {signal: abort.signal};
    const buttons = pages.map((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `${index + 1} ${root.dataset.pageLabel}`);
      button.addEventListener('click', () => carousel.show(index), options);
      return button;
    });
    dots.replaceChildren(...buttons);
    const carousel = new window.OutlumiScrollCarousel(root, viewport, pages, index => {
      buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    });
    root.querySelector('[data-brand-prev]').addEventListener('click', () => carousel.show(carousel.index - 1), options);
    root.querySelector('[data-brand-next]').addEventListener('click', () => carousel.show(carousel.index + 1), options);
    root.querySelector('.olm-brand-controls').hidden = false;
    instances.set(root, () => { abort.abort(); carousel.destroy(); dots.replaceChildren(); instances.delete(root); });
  };
  document.querySelectorAll('[data-olm-brands]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-olm-brands]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-olm-brands]').forEach(root => instances.get(root)?.()));
})();
